import { render, staticRenderFns } from "./transportationModel.vue?vue&type=template&id=c1ca6de0&scoped=true"
import script from "./transportationModel.vue?vue&type=script&lang=js"
export * from "./transportationModel.vue?vue&type=script&lang=js"
import style0 from "./transportationModel.vue?vue&type=style&index=0&id=c1ca6de0&lang=scss"
import style1 from "./transportationModel.vue?vue&type=style&index=1&id=c1ca6de0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ca6de0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1ca6de0')) {
      api.createRecord('c1ca6de0', component.options)
    } else {
      api.reload('c1ca6de0', component.options)
    }
    module.hot.accept("./transportationModel.vue?vue&type=template&id=c1ca6de0&scoped=true", function () {
      api.rerender('c1ca6de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/transportationModel.vue"
export default component.exports